var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"column_content home"},[_c('h1',[_vm._v(_vm._s(_vm.$t('slogan')))]),_c('p',[_vm._v(_vm._s(_vm.$t('intro_1')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }